/* eslint-disable import/no-cycle */
import {
  FLIGHT_WARNING,
  FLIGHT_ERROR,
  FLIGHT_AGENCY_ERROR,
  ERROR_BOOKING_INVALID_TYPE,
  ERROR_BOOKING_INVALID_STATUS,
  ERROR_BOOKING_FCC_INCOMPLETE,
  ERROR_BOOKING_NOT_FOUND,
  ERROR_CODE_LOCKED_BOOKING,
  ERROR_PAYMENT_DECLINED,
  SUCCESS_BOOKING_FCC_REDMPTION,
  BOOKING_STATUS_COURTESY_HOLD,
  UNSUCCESSFUL_BOOKING_FCC_REDEMPTION,
  INCORRECT_SAILING_BOOKING_DATE,
  BOOKING_STATUS_CANCELLED,
} from '../commons';
import {
  FCC_ACTIVE,
  FCC_CERTIFICATE_EXPIRED,
  FCC_CURRENCY_MISSMATCH,
  FCC_INVALID_STATUS,
  FCC_NAMES_MISSMATCH,
  FCC_NON_ELEGIBLE,
  FCC_REDEEMED,
  FCC_SUCCES_NOT_ACTIVE,
  FCC_TECHNICAL_ISSUES,
  INTERNAL_SERVER_ERROR,
  INVALID_SAILING,
} from '../commons/constants';

const defaultNotifications = {
  [FLIGHT_WARNING]: {
    trackingMsg: 'Invalid flight information',
    type: FLIGHT_WARNING,
  },
  [FLIGHT_ERROR]: {
    trackingMsg: 'Invalid flight information',
    type: FLIGHT_WARNING,
  },
  [FLIGHT_AGENCY_ERROR]: {
    trackingMsg: 'Invalid flight agency',
    type: FLIGHT_WARNING,
  },
  [BOOKING_STATUS_COURTESY_HOLD]: {
    trackingMsg:
      'We are sorry, your reservation cannot be retrieved. Make sure your minimum deposit has been paid',
    type: FLIGHT_WARNING,
  },
  [INCORRECT_SAILING_BOOKING_DATE]: {
    trackingMsg: 'Sailing search dates are outside of allowed time frame; -5/+330> days',
    type: FLIGHT_WARNING,
  },
  [INVALID_SAILING]: {
    trackingMsg: 'No valid sailing available',
    type: INVALID_SAILING,
  },
  [SUCCESS_BOOKING_FCC_REDMPTION]: {
    title: {
      key: 'formCruiseCreditSuccessKeyRedeemed',
      defaultValue: 'Submitted Successfully',
    },
    description: {
      key: 'formCruiseCreditSuccessMessageRedeemed',
      defaultValue:
        'Your request has been received. You will receive a confirmation email in the next 24-48 hours.',
    },
    trackingMsg: 'Redeemed Reservation',
    type: 'success',
  },
  [ERROR_BOOKING_FCC_INCOMPLETE]: {
    title: {
      key: 'formCruiseCreditErrorKeyIncomplete',
      defaultValue: 'Incomplete Reservation',
    },
    description: {
      key: 'formCruiseCreditErrorMessageIncomplete',
      defaultValue:
        'All guest information must be added to your reservation in order to redeem credit. <a class="message__description__link" href="{path_dashboard}">Edit guest information</a>',
    },
    trackingMsg: 'Incomplete Reservation',
    type: 'error',
  },
  [ERROR_BOOKING_INVALID_TYPE]: {
    title: {
      key: 'formBookingAmendErrorKeyInvalidStatus',
      defaultValue: 'Unsupported booking',
    },
    description: {
      key: 'formBookingAmendErrorMessageInvalidStatus',
      defaultValue:
        'Unfortunately we cannot service your cruise online. Please call the party that helped you create your booking.',
    },
    trackingMsg: 'Unsupported booking',
    type: 'error',
  },
  [ERROR_BOOKING_INVALID_STATUS]: {
    title: {
      key: 'formBookingAmendErrorKeyInvalidType',
      defaultValue: 'Expired courtesy hold',
    },
    description: {
      key: 'formBookingAmendErrorMessageInvalidType',
      defaultValue:
        'We’re sorry, it looks like your courtesy hold has expired. Please search for a new cruise to try again.',
    },
    trackingMsg: 'Expired courtesy hold',
    type: 'error',
  },
  [ERROR_BOOKING_NOT_FOUND]: {
    title: {
      key: 'formBookingAmendErrorKeyBookingNotFound',
      defaultValue: 'Reservation not found',
    },
    description: {
      key: 'formBookingAmendErrorMessageBookingNotFound',
      defaultValue:
        'The cruise information entered doesn’t match any of our records. Please review and try again.',
    },
    trackingMsg: 'Reservation not found',
    type: 'error',
  },
  [ERROR_CODE_LOCKED_BOOKING]: {
    title: {
      key: 'formBookingAmendErrorKeyBookingLocked',
      defaultValue: 'Booking temporarily locked',
    },
    description: {
      key: 'formBookingAmendErrorMessageBookingLocked',
      defaultValue:
        'We’re sorry, it looks like your booking is temporarily locked. Please wait 30 minutes before trying again.',
    },
    trackingMsg: 'Booking temporarily locked',
    type: 'error',
  },
  [UNSUCCESSFUL_BOOKING_FCC_REDEMPTION]: {
    title: {
      key: 'formCruiseCreditUnsuccessKeyRedeemed',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'formCruiseCreditUnsuccessMessageRedeemed',
      defaultValue:
        'We encountered an unexpected error while trying to process your information. Please try again later.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [FCC_INVALID_STATUS]: {
    title: {
      key: 'fccInvalidStatusTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccInvalidStatusDescription',
      defaultValue: 'Your FCC is not valid.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [FCC_CURRENCY_MISSMATCH]: {
    title: {
      key: 'fccCurrencyMissMatchTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccCurrencyMissMatchDescription',
      defaultValue: 'Your FCC  can only be redeemed for you reservation currency.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [FCC_TECHNICAL_ISSUES]: {
    title: {
      key: 'fccTechnicalIssuesTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccTechnicalIssuesDescription',
      defaultValue: 'Sorry we are experiencing technical difficulties. Please try again.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [FCC_ACTIVE]: {
    title: {
      key: 'fccActiveStatus',
      defaultValue: 'Submitted Successfully!',
    },
    description: {
      key: 'fccActiveStatusDescription',
      defaultValue: 'has been successfully redeemed for your reservation',
    },
    trackingMsg: 'Redeemed Reservation',
    type: 'success',
  },
  [FCC_SUCCES_NOT_ACTIVE]: {
    title: {
      key: 'fccSuccesNotActiveTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccSuccesNotActiveDescription',
      defaultValue: 'status is: ',
    },
    trackingMsg: 'Redeemed Reservation',
    type: 'error',
  },
  [FCC_NAMES_MISSMATCH]: {
    title: {
      key: 'fccNamesMissMatchTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccNamesMissMatchDescription',
      defaultValue: 'The guest names do not match FCC provided.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [FCC_NON_ELEGIBLE]: {
    title: {
      key: 'fccNonElegibleTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccNonElegibleDescription',
      defaultValue: 'Your booking is not eligle for FCC, please contact {phone_number}.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [FCC_REDEEMED]: {
    title: {
      key: 'fccRedeemedTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccRedeemedDescription',
      defaultValue: 'Your FCC has been  Redeemed.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [FCC_CERTIFICATE_EXPIRED]: {
    title: {
      key: 'fccCerticateExpiredTitle',
      defaultValue: 'Oops!',
    },
    description: {
      key: 'fccCerticateExpiredDescription',
      defaultValue: 'Your FCC has expired.',
    },
    trackingMsg: 'Unsuccessful Redeemed Reservation',
    type: 'error',
  },
  [ERROR_PAYMENT_DECLINED]: {
    title: {
      key: 'formBookingAmendErrorPaymentDeclined',
      defaultValue: 'Payment declined',
    },
    description: {
      key: 'formBookingAmendErrorMessagePaymentDeclined',
      defaultValue:
        'Your payment was declined. Please try again or use a different payment method.',
    },
    trackingMsg: 'Payment declined',
    type: 'error',
  },
  [BOOKING_STATUS_CANCELLED]: {
    title: {
      key: 'formBookingAmendErrorCancelled',
      defaultValue: 'Canceled booking',
    },
    description: {
      key: 'formBookingAmendErrorMessageCancelled',
      defaultValue: 'We are sorry, your reservation is already canceled and cannot be retrieved.',
    },
    trackingMsg: 'Payment declined',
    type: 'error',
  },
  [INTERNAL_SERVER_ERROR]: {
    title: {
      key: 'formBookingAmendTechnicalErrorTitle',
      defaultValue: 'Technical Issues',
    },
    description: {
      key: 'formBookingAmendTechnicalMessageError',
      defaultValue: 'We are experiencing technical issues. Please try again later.',
    },
    trackingMsg: 'Internal server error',
    type: 'error',
  },
};

export default defaultNotifications;
